import { lazy } from 'react';

const DirectDepositMonitoring = lazy(() =>
  import('../pages/DirectDepositMonitoring'),
);

const directDepositMonitoringRoute = {
  public: [],
  auth: [
    {
      name: 'direct_deposit_monitoring',
      path: '/treasury/direct-deposit-monitoring/:tab?',
      component: DirectDepositMonitoring,
    },
  ],
};

export default directDepositMonitoringRoute;
